import { render, staticRenderFns } from "./SubmitMessage.vue?vue&type=template&id=552c8db4&scoped=true&"
import script from "./SubmitMessage.vue?vue&type=script&lang=js&"
export * from "./SubmitMessage.vue?vue&type=script&lang=js&"
import style0 from "./SubmitMessage.vue?vue&type=style&index=0&id=552c8db4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c8db4",
  null
  
)

export default component.exports